<template>
    <div class="md-layout">
        <div class="md-layout-item md-size-100">

            <md-card>
                <md-card-header class="md-card-header-icon md-card-header-green">
                    <div class="card-icon">
                        <md-icon>assignment</md-icon>
                    </div>
                    <h4 class="title">View Vendor Details
                        <div class="text-right">
                            <md-button @click="goToEdit(institution.id)" class="md-primary md-dense">
                                <md-icon>edit</md-icon> Edit Vendor
                            </md-button>
                            <md-button @click="goBack" class="md-primary md-dense">Back to List</md-button>
                        </div>
                    </h4>
                </md-card-header>
                <md-card-content>
                    <div>
                        <div class="md-layout">
                            <div class="md-layout-item md-size-30 md-small-size-100">
                                <div class="picture-container">
                                    <div class="picture">
                                        LOGO

                                    </div>
                                </div>
                            </div>
                            <div class="md-layout-item md-size-70 mt-4 md-small-size-100">
                                <md-card-content>
                                    <md-table v-model="tableData">
                                        <md-table-row >
                                            <md-table-cell >Name:</md-table-cell> <md-table-cell >{{institution.name}} </md-table-cell>
                                        </md-table-row>
                                        <md-table-row >
                                            <md-table-cell >Business Name:</md-table-cell> <md-table-cell >{{institution.business_name}}</md-table-cell>
                                        </md-table-row>
                                        <md-table-row >
                                            <md-table-cell >Phone Number:</md-table-cell> <md-table-cell >{{institution.phone_number }} </md-table-cell>
                                        </md-table-row>
                                        <md-table-row >
                                            <md-table-cell >Land Line  Number:</md-table-cell> <md-table-cell >{{institution.telephone_number}}</md-table-cell>
                                        </md-table-row>
                                        <md-table-row >
                                            <md-table-cell >Website:</md-table-cell> <md-table-cell > {{ institution.website }} </md-table-cell>
                                        </md-table-row>
                                        <md-table-row >
                                            <md-table-cell >Email:</md-table-cell> <md-table-cell >{{institution.email}}</md-table-cell>
                                        </md-table-row>

                                    </md-table>
                                </md-card-content>
                            </div>
                        </div>
                    </div>


                </md-card-content>
            </md-card>
        </div>
        <div class="md-layout-item md-size-100">
            <md-card>
                <md-card-header class="md-card-header-icon md-card-header-green">
                    <div class="card-icon">
                        <md-icon>eye</md-icon>
                    </div>
                    <h4 class="title">Vendor Items</h4>
                </md-card-header>
                <md-card-content>
                    <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
                        <nav-tabs-card>
                            <template slot="content">
                                <span class="md-nav-tabs-title">Details:</span>
                                <md-tabs class="md-info" md-alignment="left">
                                    <md-tab id="tab-home" md-label="TakeOn" md-icon="bug_report">
                                        <md-table v-model="firstTabs" @md-selected="onSelect">
                                            <md-table-row
                                                    slot="md-table-row"
                                                    slot-scope="{ item }"
                                                    md-selectable="multiple"
                                                    md-auto-select
                                            >
                                                <md-table-cell>{{ item.tab }}</md-table-cell>
                                                <md-table-cell>
                                                    <md-button class="md-just-icon md-simple md-primary">
                                                        <md-icon>edit</md-icon>
                                                        <md-tooltip md-direction="top">Edit</md-tooltip>
                                                    </md-button>
                                                    <md-button class="md-just-icon md-simple md-danger">
                                                        <md-icon>close</md-icon>
                                                        <md-tooltip md-direction="top">Close</md-tooltip>
                                                    </md-button>
                                                </md-table-cell>
                                            </md-table-row>
                                        </md-table>
                                    </md-tab>

                                    <md-tab id="tab-parent" md-label="Invoice" md-icon="code">
                                        <md-table v-model="firstTabs" @md-selected="onSelect">
                                            <md-table-row
                                                    slot="md-table-row"
                                                    slot-scope="{ item }"
                                                    md-selectable="multiple"
                                                    md-auto-select
                                            >
                                                <md-table-cell>{{ item.tab }}</md-table-cell>
                                                <md-table-cell>
                                                    <md-button class="md-just-icon md-simple md-primary">
                                                        <md-icon>edit</md-icon>
                                                        <md-tooltip md-direction="top">Edit</md-tooltip>
                                                    </md-button>
                                                    <md-button class="md-just-icon md-simple md-danger">
                                                        <md-icon>close</md-icon>
                                                        <md-tooltip md-direction="top">Close</md-tooltip>
                                                    </md-button>
                                                </md-table-cell>
                                            </md-table-row>
                                        </md-table>
                                    </md-tab>
                                    <md-tab id="tab-education" md-label="Staff" md-icon="code">
                                        <md-table v-model="firstTabs" @md-selected="onSelect">
                                            <md-table-row
                                                    slot="md-table-row"
                                                    slot-scope="{ item }"
                                                    md-selectable="multiple"
                                                    md-auto-select
                                            >
                                                <md-table-cell>{{ item.tab }}</md-table-cell>
                                                <md-table-cell>
                                                    <md-button class="md-just-icon md-simple md-primary">
                                                        <md-icon>edit</md-icon>
                                                        <md-tooltip md-direction="top">Edit</md-tooltip>
                                                    </md-button>
                                                    <md-button class="md-just-icon md-simple md-danger">
                                                        <md-icon>close</md-icon>
                                                        <md-tooltip md-direction="top">Close</md-tooltip>
                                                    </md-button>
                                                </md-table-cell>
                                            </md-table-row>
                                        </md-table>
                                    </md-tab>
                                    <md-tab id="tab-posts" md-label="Guidance" md-icon="cloud">
                                        <md-table v-model="firstTabs" @md-selected="onSelect">
                                            <md-table-row
                                                    slot="md-table-row"
                                                    slot-scope="{ item }"
                                                    md-selectable="multiple"
                                                    md-auto-select
                                            >
                                                <md-table-cell>{{ item.tab }}</md-table-cell>
                                                <md-table-cell>
                                                    <md-button class="md-just-icon md-simple md-primary">
                                                        <md-icon>edit</md-icon>
                                                        <md-tooltip md-direction="top">Edit</md-tooltip>
                                                    </md-button>
                                                    <md-button class="md-just-icon md-simple md-danger">
                                                        <md-icon>close</md-icon>
                                                        <md-tooltip md-direction="top">Close</md-tooltip>
                                                    </md-button>
                                                </md-table-cell>
                                            </md-table-row>
                                        </md-table>
                                    </md-tab>
                                    <md-tab id="tab-pages" md-label="TakeOn" md-icon="code">
                                        <md-table v-model="firstTabs" @md-selected="onSelect">
                                            <md-table-row
                                                    slot="md-table-row"
                                                    slot-scope="{ item }"
                                                    md-selectable="multiple"
                                                    md-auto-select
                                            >
                                                <md-table-cell>{{ item.tab }}</md-table-cell>
                                                <md-table-cell>
                                                    <md-button class="md-just-icon md-simple md-primary">
                                                        <md-icon>edit</md-icon>
                                                        <md-tooltip md-direction="top">Edit</md-tooltip>
                                                    </md-button>
                                                    <md-button class="md-just-icon md-simple md-danger">
                                                        <md-icon>close</md-icon>
                                                        <md-tooltip md-direction="top">Close</md-tooltip>
                                                    </md-button>
                                                </md-table-cell>
                                            </md-table-row>
                                        </md-table>
                                    </md-tab>
                                </md-tabs>
                            </template>
                        </nav-tabs-card>
                    </div>
                </md-card-content>
            </md-card>
        </div>
    </div>
</template>
<script>
import {
    NavTabsCard,
} from '@/components';


export default {
    components: {
        NavTabsCard,
    },
    data () {
        return {
            institution: {
                type: 'institutions',
                name: null,
                description: null,
                business_name: null,
                address: null,
                phone_number: null,
                email: null,
                website: null,
                logo: null,
                uuid: null
            },
            firstTabs: [
                {
                    tab: 'Sign contract for "What are conference organizers afraid of?"'
                },
                {
                    tab: 'Lines From Great Russian Literature? Or E-mails From My Boss?'
                },
                {
                    tab:
                            'Flooded: One year later, assessing what was lost and what was found when a ravaging rain swept through metro Detroit'
                }
            ],
            secondTabs: [
                {
                    tab: 'Sign contract for "What are conference organizers afraid of?"'
                },
                {
                    tab: 'Lines From Great Russian Literature? Or E-mails From My Boss?'
                },
                {
                    tab:
                            'Flooded: One year later, assessing what was lost and what was found when a ravaging rain swept through metro Detroit'
                }
            ],
            thirdTabs: [
                {
                    tab: 'Sign contract for "What are conference organizers afraid of?"'
                },
                {
                    tab: 'Lines From Great Russian Literature? Or E-mails From My Boss?'
                },
                {
                    tab:
                            'Flooded: One year later, assessing what was lost and what was found when a ravaging rain swept through metro Detroit'
                }
            ],
            fourthTabs: [
                {
                    tab: 'Sign contract for "What are conference organizers afraid of?"'
                },
                {
                    tab: 'Lines From Great Russian Literature? Or E-mails From My Boss?'
                },
                {
                    tab:
                            'Flooded: One year later, assessing what was lost and what was found when a ravaging rain swept through metro Detroit'
                }
            ],
        };
    },
    created () {
        this.get();
    },
    computed: {
        shoppingTotal () {
            return this.shoppingCartTable.reduce((accumulator, current) => {
                return accumulator + current.amount;
            }, 0);
        }
    },
    methods: {
        async get () {
            try {
                const id = this.$route.params.id;
                await this.$store.dispatch('institutions/get', id);
                this.institution = this.$store.getters['institutions/institution'];
            } catch (e) {
                await this.$store.dispatch(
                    'alerts/error',
                    'Oops, something went wrong!'
                );
            }
        },
        goToEdit (id) {
            this.$router.push({ name: 'Edit Vendor', params: { id } });
        },
        goBack () {
            this.$router.push({ name: 'Vendors List' });
        },

    }
};
</script>
<style lang="scss" scoped>
    .text-right .md-table-cell-container {
        display: flex;
        justify-content: flex-end;
    }
    .md-table .md-table-head:last-child {
        text-align: right;
    }

    .table-stats {
        display: flex;
        align-items: center;
        text-align: right;
        flex-flow: row wrap;

    .td-price .td-total {
        display: inline-flex;
        font-weight: 500;
        font-size: 1.0625rem;
        margin-right: 50px;
    }

    &.table-striped .td-price {
         border-bottom: 0;
     }

    .td-price {
        font-size: 26px;
        border-top: 1px solid #ddd;
        border-bottom: 1px solid #ddd;
    }

    .td-price,
    > div {
        flex: 0 0 100%;
        padding: 12px 8px;
    }
    }

    .table-shopping .md-table-head:nth-child(5),
    .table-shopping .md-table-head:nth-child(7),
    .table-shopping .md-table-head:nth-child(6) {
        text-align: right;
    }
</style>

